import React from "react";
import styled from "styled-components";

const TabMenuContainer = styled.div`
  width: fit-content;
  border: 1px solid #1f49e6;
  border-radius: 5px;
  display: flex;
  align-items: center;
  align-content: center;
  margin-bottom: 4px;

  div:first-child {
    border-radius: 3px 0 0 3px;
  }

  div:last-child {
    border-radius: 0 3px 3px 0;
  }
`;

const StyledTab = styled.div`
  position: relative;
  box-sizing: border-box;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 16px;
  line-height: 16px;
  background-color: #ffffff;
  color: #000000;
  cursor: pointer;
  padding: 8px 24px;
  width: fit-content;

  &:hover {
    background-color: #dadde1;
  }

  ${(props) =>
    props.isActive &&
    `
      background-color: #1f49e6;
      color: #ffffff;

      &:hover {
        background-color: #657bed;
        color: #ffffff;
      }
  `}

  ${(props) =>
    props.hasIndicator &&
    `
      &::after {
        content: "";
        position: absolute;
        z-index: 10;
        top: -5px;
        right: -3px;
        width: 10px;
        height: 10px;
        background-color: red;
        border-radius: 999px;
      }
  `}
`;

const StyledTabContent = styled.div`
  padding-top: 20px;
  text-align: left;
`;

export const TabContentTitle = styled.div`
  margin-bottom: 16px;
`;

export const Tab = ({ value, children, activeTab, setActiveTab, hasIndicator }) => {
  return (
    <StyledTab
      isActive={activeTab === value}
      onClick={() => setActiveTab(value)}
      hasIndicator={hasIndicator}
    >
      {children}
    </StyledTab>
  );
};

export const TabContent = ({ style, value, activeTab, children }) => {
  return activeTab === value ? <StyledTabContent style={style}>{children}</StyledTabContent> : null;
};

export const TabMenu = ({ style, children }) => {
  return <TabMenuContainer style={style}>{children}</TabMenuContainer>;
};
